/**
 * The signal-quality HUD's user setting, persisted in localStorage.
 *
 * The HUD is a production surface and shows whenever a calibrated reading exists; this
 * toggle only lets a user hide the drawing. It lives beside the player stores so both the
 * beacon player and the quickstart player read the same value, and the gamepad Options
 * menu (the mobile settings menu) can flip it.
 */
import { makeStateStore } from '@playcastdotio/StateStore';

const STORAGE_KEY = 'playcast.signalBarsEnabled';

const readPersisted = (): boolean => {
  if (typeof window === 'undefined' || !('localStorage' in window)) return true;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  // Absent = default ON. Only an explicit 'false' turns the HUD off.
  return raw === null ? true : raw !== 'false';
};

export const signalBarsState = makeStateStore<{ enabled: boolean }>({
  enabled: readPersisted(),
});

export const setSignalBarsEnabled = (enabled: boolean): void => {
  signalBarsState.updateState({ enabled });
  if (typeof window !== 'undefined' && 'localStorage' in window) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(enabled));
  }
};
